import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { TemplatesPage } from '@/pages/dashboard/templates'

export default function OneOnOneTemplateCreatePlaceholder() {
  return (
    <div className="min-h-screen bg-background p-6 space-y-6">
      <Card className="border-dashed max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle>Create 1-on-1 template</CardTitle>
          <CardDescription>
            This route will reuse the unified template builder from the Next.js frontend. Until the migration is complete, manage
            templates from the main templates dashboard.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button asChild>
            <Link to="/templates">Open template library</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/dashboard/one-on-ones/templates">Back to 1-on-1 templates</Link>
          </Button>
        </CardContent>
      </Card>

      <div className="max-w-6xl mx-auto">
        <TemplatesPage />
      </div>
    </div>
  )
}
